const Form053SC = {
    stepName: {
        importantNotes: "重要事项",
        information: "基本资料",
        SelectApplyType: "选择甲部／乙部",
        SectionA: "甲部",
        SectionB: "乙部",
        CGHP: "宿舍家长现金津贴",
        certification: "确认",
    },
    title: {
        note: "注",
        noteTitle: "个人资料收集声明",
        schoolInformation: "学校资料",
        CGHP: "宿舍家长现金津贴",
        selectMessage: "请选择您需要的：",
        sectionACGHP: "甲部 以宿舍家长的空缺职位换取「津贴」",
        vacancyPeriod: "空缺冻结期(不得少于30天)",
        vacantPost: "空缺职位",
        indicateDocuments: "请注明以下文件：",
        sectionBCGHP:
            "乙部 以「津贴」代替宿舍家长放取不少于30天核准假期的临时补缺人员安排",
        leaveInformation: "休假宿舍家长的资料",
        applyTitle: "请选择所需津贴申请：",
    },
    label: {
        revokeOrNot: "请选择",
        irrevocable: "不可撤回",
        revocable: "可撤回",
        revokOptions: {
            irrevocable: "不可撤回",
            revocable: "可撤回",
        },
        revokeRefLabel: "请填写",

        termsConditions: "我已阅读、理解并同意上述条款和条件。",
        statementTwo: "本人理解申请人和教师需要拥有「智方便+」帐户才能处理申请。",
        schoolName: "学校名称",
        schoolCode: "学校代码",
        month: "月份",
        year: "年份",
        situationOfCGHP: "宿舍家长现金津贴",
        from: "由",
        to: "至",
        schoolYear: "学年",
        houseparentTotalNumber: "a. 编制内宿舍家长的职位总数",
        irrevocableNumber: "b. 不可撤回的冻结宿舍家长空缺职位数目",
        irrevocableDate: "教育局批函发出日期",
        revocableNumber: "c. 可撤回的冻结宿舍家长空缺职位数目",
        revocableDate: "教育局批函发出日期",
        attachment: "批准书",
        attachment1: "强积金供款证明资料",
        attachment2: "随附(前次日期)的申领表格副本",
        vacantPercentage:
            "d. 宿舍家长空缺职位申领现金津贴的百分比率 [(b+c)/(a)*100%]",
        periodText: `本人欲申报资料如下：`,
        periodText1: `在`,
        periodText2: `学年，由`,
        periodText3: `至`,
        periodText4: `本校申领「宿舍家长现金津贴(「津贴」)的情况如下`,
        sectionACGHPText: "甲部：以宿舍家长的空缺职位换取「津贴」",
        sectionBCGHPText:
            "乙部：以「津贴」代替宿舍家长放取不少于30天核准假期的临时补缺人员安排",
        sectionANote2: "(请在适当地方加上「√」号",
        sectionANote3: "合资格月数",
        sectionANote4: "月薪",
        sectionANote5: "强积金供款津贴",
        sectionACGHPAmount: "「津贴」金额",
        irrevocableTotal: "总计(不可撤回)",
        revocableTotal: "总计(可撤回)",
        amountTotal: "总计(「津贴」金额)",
        claim: "新申领津贴的职位/修订",
        claimOptions: {
            N: "新申领津贴的职位",
            R: "修订",
        },
        previousClaim: "本学年已提交之申请表格",
        previousClaimOptions: {
            U: "不更改前次申领表格",
            D: "删除前次申领表格",
            C: "更改前次申领表格",
        },
        applicationNumber: "请注明前次申领表格编号",
        applicationNumberErr: "申请编号",
        previousClaimDate: "前次申领表格日期",
        freezingFrom: "空缺冻结期由",
        freezingTo: "空缺冻结期至",
        datedAttached: "附上之前索赔的副本",
        remark: "评论",
        fileSize: "每个文件的最大大小为：5MB",
        fileType: "可接受的文件类型：PDF、JPEG、PNG",
        fileNum: "最大文件数：8",
        name: "姓名",
        SRN: "职员参考编号",
        post: "职位数量",
        leavePeriodFrom: "休假时期由",
        leavePeriodTo: "休假时期至",
        absenceReason: "缺勤原因",
        CGHPInformation: "「津贴」的资料",
        qualifiedPeriodFrom: "合资格时期由",
        qualifiedPeriodTo: "合资格时期至",
        qualifiedMonthNo: "合资格月数(a)",
        monthlySalary: "月薪(b)",
        MPFSubsidy: "强积金供款津贴(c)",
        sectionBCGHPAmount: "「津贴」金额 (d) = (a) * (b) + (c)",
        certify: "本人证实 –",
        freezingPeriod: "空缺冻结期",
        leavePeriod: "休假时期",
        contactPerson: "联络人",
        tel: "电话号码",
        sSDO: "高级学校发展主任",
        sSDOValue: {
            0: "北区",
            1: "葵青区",
            2: "西贡区",
            3: "东区",
            4: "屯门区",
            5: "九龙城区",
            6: "观塘区",
            7: "南区",
            8: "油尖旺区",
            9: "荃湾区",
            10: "沙田区",
            11: "深水埗区",
            12: "大埔区",
            13: "湾仔区",
            14: "离岛区",
            15: "中西区",
            16: "元朗区",
            17: "黄大仙区",
        },
    },
    message: {
        exceedsHPposts: "已兑现的空缺HP职位的百分比超过40%的上限",
        toMessage: "致: 教育局经常津贴组",
        attnMessage: "[经办人︰一级会计主任(经常津贴)]",
    },
    errorMsg: {
        least30Days: "休假日期少于30历日，请重新选择。",
        freezing30Days: "空缺冻结期必须为最少30历日",
        E001: "只能是字母数字",
        E002: "合资格时期开始时间不能早于休假时期开始时间",
        maxDigitADecimal: "此项必须为最多{{maxDigit}}位数及小数位",
        maxTextLength: "此项必须为最多{{max}}个字",
        afterDate: "请输入{{date}}或之后的日期",
        noLeadingZero: "数字不能以0开头",
        afterAug31: "休假时期不能在该学年的八月三十一日之后",
        freezingToAfterAug31: "空缺冻结期不能在该学年的八月三十一日之后",
        qualifiedToAfterAug31: "合资格时期不能在该学年的八月三十一日之后",
        withinSchoolYear: "已超出学年范围内",
        schoolYearFormat: "学年格式必须为“XXXX/YYYY”",
    },
    monthOption: {
        jan: "01",
        feb: "02",
        mar: "03",
        apr: "04",
        may: "05",
        jun: "06",
        jul: "07",
        aug: "08",
        sep: "09",
        oct: "10",
        nov: "11",
        dec: "12",
    },
    note: {
        note1:
            `1. 在事先取得大部分宿舍家长对现金津贴申领的同意及在宿舍服务质素不受负面影响的情况下，特殊学校最多可将每学年宿舍家长编制的20%空缺职位申领现金津贴。` +
            `如个别学校有意以多于编制内20%的宿舍家长空缺职位申领现金津贴，在作任何招聘额外员工的安排之前，必须事先取得教育局的批准。` +
            `如欲事先取得教育局批准，有关学校须向教育局特殊教育支援第一组(地址：香港添马添美道2号政府总部东翼5楼)提交书面申请，并列明理据，以便考虑。` +
            `可撤回的冻结宿舍家长空缺职位的批准只适用于相关学年，至于不可撤回的冻结宿舍家长空缺职位的批准(包括在此通函生效日期前已取得的批准)，只要其获批冻结及申领现金的宿舍家长职位数目等于或低于宿舍家长编制40%的申领上限，便适用于获批的相关及往后学年。` +
            `在任何情况下，宿舍家长空缺职位的现金津贴申领均不可超逾每学年宿舍家长编制的40%。如以宿舍家长编制的20%或40%的现金津贴申领上限导致个别学校的宿舍家长职位数目出现小数，该小数将下调至最接近的整数。` +
            `在任何情況下，宿舍家長空缺職位的現金津貼申領均不可超逾每學年宿舍家長編制的40%。` +
            `如以宿舍家長編制的20%或40%的現金津貼申領上限導致個別學校的宿舍家長職位數目出現小數，該小數將下調至最接近的整數。` +
            `在超逾每学年宿舍家长编制20%的空缺职位作现金津贴申领，学校向经常津贴组提交申领表格时，必须一并提交特殊教育支援第一组的有关批函。`,
        note2: `2. 不可撤回及可撤回的宿舍家长职位冻结及现金津贴的申请均须每年提交。学校须在有关学年内提交申领表格。`,
        note3: `3. 计算由起始日直至完结日(首尾两天包括在内)的合资格申领「津贴」月数，包含以下三个元素：`,
        note4: `(i) 合资格日数在起始月份的历日总数中所占的比例(如适用)；`,
        note5: `(ii) 完整的历月数(如适用)；以及`,
        note6: `(iii) 合资格日数在完结月份历日总数中所占的比例(如适用)。`,
        note7: `例如：`,
        note8: `假设合资格申领「津贴」的时期是由二月五日至五月二十六日，计算合资格月数的方法如下：`,
        note9: `(i)在起始月份的合资格日数为24日(二月五日至二月二十八日)除以28日(二月份的历日总数) = 0.857个月；`,
        note10: `(ii)由三月至四月有两个完整的历月数；`,
        note11: `(iii)完结月份的合资格日数为26日(五月一日至二十六日)除以31日(五月份的历日总数) = 0.839 个月；以及`,
        note12: `(iv)合资格申领月数应为上述三个元素的总和(计算至三个小数位)，即0.857 + 2 + 0.839 = 3.696。`,
        note13: `4. 填写宿舍家长职位的中点薪金，由二零一三／一 四学年起，宿舍家长的中点薪金为总薪级表第16点。`,
        note14: `5. 如合资格申领期达60天或以上，强积金计划雇主供款(月薪的5%，并以现行强积金规例所订的最高金额为上限)将会包括在内。如宿舍家长休假少于60个历日，而就其临时补缺安排须向强积金供款，请提供证明资料。`,
        note15: `6. 填写休假宿舍家长的职员参考编号。`,
        note16: `7. 请注意，学校必须按照教育局通告第1/2006号规定批假。`,
        note17: `(i) 本校已获法团校董会/校董会及大多数宿舍家长同意，在本学年上述期间冻结甲部所载的宿舍家长职位；`,
        note18: `(ii) 冻结甲部所载的宿舍家长职位并申领「津贴」，是因为该(等)核准编制的职位在上述申领期间有空缺及此项申领符合「津贴」所列明的申领条件；`,
        note19: `(iii) 本校没有就甲部和乙部所载的相同休假/空缺，向政府提出其他的申请；以及本校将把任何多收取的任何一次退还教育局。`,
        note20: `申请人应仔细阅读并同意`,
        note21: `关于私人数据的注意事项`,
        note22: `新：新申领津贴的职位/修订：修订申领(随附(前次日期)的申领表格副本)`,

        note23: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        note24: "(a) 办理与聘用有关的事宜；",
        note25: "(b) 处理发放薪金津贴，以及计算公积金的供款和赠款；",
        note26: "(c) 进行核数工作；",
        note27: "(d) 进行研究及统计资料，以便规划教育服务；",
        note28: "(e) 处理有关教育专业人员发展的事宜；",
        note29: "(f) 执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",
        note30: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        note31: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        note32: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        note33: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },
};
export default Form053SC;
